import React from 'react';

import TextIcon from '@atlaskit/icon/core/text';

export const SuggestTitleIcon = () => <TextIcon label="" color="currentColor" spacing="spacious" />;
